export function formatCasualParkingDateTime(value?: string | Date | null): string {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Parse dd/mm/yyyy HH:mm (24h) entered in casual parking forms. */
export function parseCasualParkingDateTimeInput(value?: string | null): Date | null {
  if (!value?.trim()) return null;

  const trimmed = value.trim();
  const displayMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})$/);
  if (displayMatch) {
    const [, day, month, year, hours, minutes] = displayMatch;
    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hours),
      Number(minutes),
      0,
      0,
    );
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getCasualParkingInvoiceContent(invoice: {
  casualParkingFrom?: string | Date | null;
  casualParkingTo?: string | Date | null;
  notes?: string | null;
}): string {
  if (invoice.casualParkingFrom && invoice.casualParkingTo) {
    return `Thu tiền xe vãng lai từ ${formatCasualParkingDateTime(invoice.casualParkingFrom)} đến ${formatCasualParkingDateTime(invoice.casualParkingTo)}`;
  }
  return invoice.notes || '—';
}
